import React, { useState } from "react";
import { Button, Row, Col, Form, Input, notification, Flex } from "antd";
import strings from "../../constants/constants";
import ClipLoader from "react-spinners/ClipLoader";
import { componentStyles } from "./SignInStyles";
import ava1 from "../../assets/images/my-friend-logo-blue.svg";
import rules from "../../validations";
import { useNavigate } from "react-router-dom";
import { authenticated, signIn } from "../../redux/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {
  AUTH_TOKEN,
  IS_PASSWORD_SYSTEM_GENERATED,
  IS_PSUEDO_NAME_SYSTEM_GENERATED,
  ACCOUNT_SETUP_COMPLETED,
} from "../../redux/constants/Auth";
import { loginUser } from "../../api/password";
import { postRequest } from "../../api";
import Footer from "../../components/layout/Footer";

export const SignIn = (props) => {
  const [messageApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [systemUser, setSystemUser] = useState({});
  const [loader, setLoader] = useState(false);

  const setUserInfo = (user) => {
    localStorage.setItem(AUTH_TOKEN, user.token);
    localStorage.setItem("userid", user.id);
    localStorage.setItem("useremail", user.email);
    localStorage.setItem("username", user.name);
    localStorage.setItem(IS_PASSWORD_SYSTEM_GENERATED, user.systemGeneratedPassword);
    localStorage.setItem("age", user.age);
    localStorage.setItem("userPlatform", user.platform);
    localStorage.setItem(ACCOUNT_SETUP_COMPLETED, user.AccountSetupCompleted);
  };

  const handlePathCreation = () => {
    const isPassword =
      localStorage.getItem(IS_PASSWORD_SYSTEM_GENERATED) === "true"
        ? true
        : false;
    const isUsername =
      localStorage.getItem(IS_PSUEDO_NAME_SYSTEM_GENERATED) === "true"
        ? true
        : false;
    const isSetupCompleted =
      localStorage.getItem(ACCOUNT_SETUP_COMPLETED) === "true"
        ? true
        : false;
    if (isPassword) {
      navigate("/set-password");
    } else if (isPassword !== true && isUsername && true) {
      navigate({ pathname: "/set-username" });
    } else if (!isSetupCompleted) {
      navigate('/onboarding/welcome');
    } else {
      navigate("/landing-page", { state: { userId: systemUser.id } });
    }
  };

  const handleSystemUserChange = ({ target: { name, value } }) => {
    setSystemUser({
      ...systemUser,
      [name]: value,
    });
  };
  const handleChange = (name, value) => {
    handleSystemUserChange({ target: { name, value } });
  };

  const onSubmit = () => {
    form.validateFields().then(() => {
      signInRequest();
    });
  };

  const signInRequest = async () => {
    setLoader(true);
    try {
      const response = await postRequest("/user/login", systemUser);
      setLoader(false);
      if (response.error || response.message) {
        messageApi.error({
          message: "Error",
          description: response.error
            ? `${response.error}`
            : `${response.message}`,
        });
      } else {
        setUserInfo(response);
        handlePathCreation();
      }
    } catch (error) {
      messageApi.error({
        message: "Error",
        description: error.error ? error.error : error.message,
      });
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div style={{ maxHeight: "100dvh" }}>
      <Row
        style={componentStyles.outer}
      >
        <Col lg={12} md={16} xs={22}>
          <div
            style={componentStyles.outer}
          >
            <div
              style={componentStyles.inner}
            >
              <div
                style={componentStyles.marginAuto}
              >
                <img
                  style={componentStyles.logoinLogoStyle}
                  src={ava1}
                  alt="logo"
                />
              </div>
              <div
                style={componentStyles.marginAuto}
              >
                <span style={componentStyles.signInHeading}>
                  {strings.signIn}
                </span>
              </div>
              <div
                style={componentStyles.marginAuto}
              >
                <span style={componentStyles.signInDescription} level={5}>
                  {strings.enterUserName}
                </span>
              </div>
              {contextHolder}
              <Form
                form={form}
                onFinish={onSubmit}
                onFinishFailed={onFinishFailed}
                layout="vertical"
              >
              <Row style={componentStyles.flexCenter}>
                <Col className="pt-2" lg={16} md={16} xs={22}>
                  <Form.Item
                    className="username"
                    label="Email"
                    name="email"
                    rules={[
                            ...rules.email,
                            ...(process.env.REACT_APP_ENV === 'production'
                              ? [
                                  {
                                    validator: (_, value) => {
                                      if (value && /\+/.test(value)) {
                                        return Promise.reject(
                                          new Error("Email addresses with '+' are not allowed.")
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  },
                                ]
                              : []),
                          ]}
                    style={componentStyles.formInput}
                  >
                    <Input
                      placeholder="Email"
                      maxLength={255}
                      type="text"
                      onChange={(e) => handleChange("email", e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
               <Row style={componentStyles.flexCenter}>
                  <Col className="pt-2" lg={16} md={16} xs={22}>
                    <Form.Item
                      className="username"
                      label="Password"
                      name="password"
                      rules={rules.password}
                      style={componentStyles.formInput}
                    >
                      <Input.Password
                        placeholder="Password"
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                        onChange={(e) => handleChange("password", e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row  style={componentStyles.flexCenter}>
                  <Col  lg={16} md={16} xs={22}>
                    <div class="text-right pt-2"
                      style={componentStyles.forgotPasswordLink}
                    >
                      <a style={componentStyles.forgotPasswordLink} onClick={() => navigate("/forgot-password")}>Forgotten password? <span style={componentStyles.forgotPasswordLink2}>Reset here.</span></a>
                    </div>
                  </Col>
                </Row>
                <Form.Item class="pt-2" style={componentStyles.centerFormButton}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={componentStyles.signInButton}
                    class="text-center"
                  >
                    {loader ? (
                      <ClipLoader
                        color="#fff"
                        loading={loader}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>{strings.signIn}</span>
                    )}
                  </Button>
                  <div class="text-center pt-2" style={componentStyles.SignupLink}>
                    Don’t have an account?{" "}
                    <a style={componentStyles.SignupLink2} onClick={() => navigate("/signup")}>Sign Up here</a>
                  </div>
                </Form.Item>
              </Form>
              <Row>
                <Col xs={24}>
                  <p style={componentStyles.privacyPolicyTextStyle}>
                    {strings.privacyPolicyText}
                    <a href={strings.privacyPolicyLink} target="_blank">
                      Privacy Policy
                    </a>
                  </p>
                  <p style={componentStyles.privacyPolicyTextStyle}>
                    {strings.helpSupportText}
                    <a href={strings.helpSupportLink} target="_blank">
                      Help & Support
                    </a>
                  </p>  
                </Col>
              </Row>
            </div>

          </div>
        </Col>

      </Row>
      <Row style={componentStyles.fixFooter}>
        <Col xs={24}>
          <Footer />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = ({ auth, site, roles }) => {
  const { token } = auth;
  return {
    signInMessage: auth.userObject,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signIn,
      authenticated,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
